{
  "name": "radianui",
  "description": "Add components to your project",
  "version": "0.1.0",
  "main": "index.js",
  "type": "module",
  "publishConfig": {
    "access": "public"
  },
  "exports": "./dist/index.js",
  "bin": {
    "radianos": "dist/index.js"
  },
  "files": [
    "dist",
    "README.md",
    "package.json"
  ],
  "scripts": {
    "dev": "tsup --watch && tsup",
    "build": "tsup",
    "release": "changeset version",
    "pre:enter": "changeset pre enter alpha",
    "pre:exit": "changeset pre exit",
    "pub:alpha": "pnpm build && pnpm publish --no-git-checks --access public --tag alpha",
    "pub:next": "pnpm build && pnpm publish --no-git-checks --access public --tag next",
    "pub:release": "pnpm build && pnpm publish --no-git-checks --access public",
    "unit": "vitest run unit",
    "e2e": "vitest run cli",
    "test": "vitest run",
    "update-snapshot": "vitest -u",
    "coverage": "vitest run --coverage"
  },
  "keywords": [
    "radian",
    "radianos",
    "radianos cli",
    "components",
    "ui",
    "tailwind",
    "radix-ui"
  ],
  "author": "RadianOS <radianos44@gmail.com> (https://radianos.com)",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/Radian-os/radianos"
  },
  "homepage": "https://github.com/Radian-os/radianos#readme",
  "dependencies": {
    "@clack/prompts": "^0.9.1",
    "adm-zip": "^0.5.16",
    "chalk": "^5.3.0",
    "commander": "^12.1.0",
    "cosmiconfig": "^9.0.0",
    "execa": "^9.5.0",
    "fast-glob": "^3.3.2",
    "fs-extra": "^11.2.0",
    "gradient-string": "^3.0.0",
    "json5": "^2.2.3",
    "node-fetch": "^3.3.2",
    "ora": "^8.1.0",
    "package-manager-detector": "^1.3.0",
    "postcss": "^8.5.6",
    "prompts": "^2.4.2",
    "ts-morph": "^25.0.1",
    "tsconfig-paths": "^4.2.0",
    "tsup": "^8.3.5",
    "type-fest": "^4.26.1",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@types/adm-zip": "^0.5.7",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^22.7.9",
    "@types/prompts": "^2.4.9",
    "@vitest/coverage-istanbul": "^3.2.4",
    "typescript": "^5.6.3",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "^3.2.4"
  }
}